export default "__VITE_ASSET__e673671e__"